<nav class="border-b border-border-light w-full fixed top-0 z-10 h-16 backdrop-blur-xs">
    <div class="h-full flex items-center justify-between">
        <div class="h-full px-4 md:px-6 border-r border-border-light flex-center">
            <a href="/">
                <img src="assets/icons/drazamed_letters.svg" alt="Drazamed" class="w-32 md:w-60">
            </a>
        </div>
        
        <!-- Desktop Menu -->
        <div class="hidden md:flex h-full w-full items-center px-10">
            <ul class="flex items-center gap-6">
                <li class="cursor-pointer font-light" routerLink="/">Inicio</li>
                <li class="cursor-pointer font-light" routerLink="/features">Producto</li>
                <li class="cursor-pointer font-light" routerLink="/contact">Contacto</li>
            </ul>
        </div>
        
        <!-- Desktop Button -->
        <button class="hidden md:block bg-black text-white h-full w-1/4 cursor-pointer hover:bg-black-800 active:bg-black-900" routerLink="/auth/login">Ingresar</button>
        
        <!-- Mobile Menu Button -->
        <button 
            class="md:hidden px-4 h-full flex items-center justify-center"
            (click)="toggleMenu()"
            aria-label="Toggle menu">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                @if (isMenuOpen()) {
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                } @else {
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                }
            </svg>
        </button>
    </div>
    
    <!-- Mobile Menu -->
    @if (isMenuOpen()) {
        <div class="md:hidden absolute top-16 left-0 w-full bg-white border-b border-border-light shadow-lg">
            <ul class="flex flex-col">
                <li class="cursor-pointer font-light px-6 py-4 border-b border-border-light hover:bg-gray-50" routerLink="/" (click)="closeMenu()">Inicio</li>
                <li class="cursor-pointer font-light px-6 py-4 border-b border-border-light hover:bg-gray-50" routerLink="/features" (click)="closeMenu()">Producto</li>
                <li class="cursor-pointer font-light px-6 py-4 border-b border-border-light hover:bg-gray-50" routerLink="/contact" (click)="closeMenu()">Contacto</li>
                <!-- <li class="px-6 py-4">
                    <button class="w-full bg-black text-white py-3 rounded cursor-pointer hover:bg-black-800 active:bg-black-900" routerLink="/auth/login" (click)="closeMenu()">Ingresar</button>
                </li> -->
            </ul>
        </div>
    }
</nav>
